var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9235 0.487305C6.08361 0.487305 0.487305 6.08361 0.487305 12.9235C0.487305 19.7635 6.08361 25.3598 12.9235 25.3598C19.7635 25.3598 25.3598 19.7635 25.3598 12.9235C25.3598 6.08361 19.7635 0.487305 12.9235 0.487305ZM17.3384 17.6493L12.2644 14.5278C11.8913 14.304 11.6675 13.906 11.6675 13.4707V7.63814C11.6799 7.12826 12.1028 6.70543 12.6126 6.70543C13.1225 6.70543 13.5454 7.12826 13.5454 7.63814V13.1723L18.3209 16.045C18.7686 16.3186 18.9178 16.9031 18.6442 17.3509C18.3706 17.7861 17.7861 17.9229 17.3384 17.6493Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEta);
export default __webpack_public_path__ + "static/media/eta.35c5ebd75fca43289869aa41e2270856.svg";
export { ForwardRef as ReactComponent };